import { useState } from 'react';
import type { PublicationRow, PublishOptions } from '../publishingApi';
import { field, channelLabel } from './publishingUi';
import { ModalActions } from '../../../components/PromptDialog';
import { PublishingDialog } from './PublishingDialog';
export function EditPublication({
  error,
  row,
  busy,
  close,
  save,
}: {
  error: string;
  row: PublicationRow;
  busy: boolean;
  close: () => void;
  save: (input: { date: string; time: string; options: PublishOptions }) => Promise<void>;
}) {
  const [date, setDate] = useState(row.date);
  const [time, setTime] = useState(row.time);
  const [options, setOptions] = useState(row.options);
  return (
    <PublishingDialog title="Termin ändern" close={close} submit={() => void save({ date, time, options })}>
      {error && (
        <p role="alert" className="mb-3 text-sm">
          {error}
        </p>
      )}
      <p className="mb-3 text-sm">
        {row.title} · {channelLabel(row.channel)}. Ein aktiver Auftrag wird angehalten und muss danach neu
        bestätigt werden.
      </p>
      <label className="block text-sm">
        Datum
        <input
          required
          className={field}
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </label>
      <label className="my-3 block text-sm">
        Uhrzeit (Berlin)
        <input
          required
          className={field}
          type="time"
          value={time}
          onChange={(e) => setTime(e.target.value)}
        />
      </label>
      {row.channel === 'YOUTUBE' && (
        <>
          <label className="flex gap-2 text-sm">
            <input
              type="checkbox"
              checked={options.madeForKids}
              onChange={(e) => setOptions((o) => ({ ...o, madeForKids: e.target.checked }))}
            />
            Speziell für Kinder erstellt
          </label>
          <p className="mt-2 text-xs">
            Sichtbarkeit: öffentlich. Ein Shorts-Cover bei Bedarf in YouTube Studio setzen.
          </p>
        </>
      )}
      {row.channel === 'INSTAGRAM' && (
        <label className="flex gap-2 text-sm">
          <input
            type="checkbox"
            checked={options.shareToFeed}
            onChange={(e) => setOptions((o) => ({ ...o, shareToFeed: e.target.checked }))}
          />
          Reel auch im Feed teilen
        </label>
      )}
      {row.channel === 'FACEBOOK' && (
        <label className="block text-sm">
          Facebook-Format
          <select
            className={field}
            value={options.facebookMediaType}
            onChange={(e) =>
              setOptions((o) => ({ ...o, facebookMediaType: e.target.value as 'REELS' | 'VIDEO' }))
            }
          >
            <option value="REELS">Reel</option>
            <option value="VIDEO">Seitenvideo</option>
          </select>
        </label>
      )}
      <ModalActions onCancel={close} confirmLabel="Plan speichern" disabled={busy} />
    </PublishingDialog>
  );
}
